// Please keep this enum in alphabetical order
export enum FormatContentId {
  ActivityLogChangeFromTo = 'cid$#3070963#',
  ActivityLogChangeFrom = 'cid$#3201701#',
  ActivityLogChangeTo = 'cid$#3201702#',
  AddAnother = 'cid$#3408221#',
  AddSeatingToCart = 'cid$#____AddSeatingToCart#',
  AdjustFxRatePurchaseOrder = 'cid$#____AdjustFxRatePurchaseOrder#',
  AllocateRetailPayment = 'cid$#____AllocateRetailPayment#',
  AllOnThisPageSelected = 'cid$#____AllOnThisPageSelected#',
  AndXMore = 'cid$#2982718#',
  ApplyFilterToReduceCountsToSeeData = 'cid$#3543237#',
  ApplyToAllEventsConfirmation = 'cid$#3361820#',
  AutoPricedListingsRollupMetric = 'cid$#____AutoPricedListingsRollupMetric#',
  AvgOfTheXCheapestListings = 'cid$#3988449#',
  BaseBidExceedsBudgetError = 'cid$#____BaseBidExceedsBudgetError#',
  BoostNEvents = 'cid$#____BoostNEvents#',
  BroadcastStatusRollupMetric = 'cid$#____BroadcastStatusRollupMetric#',
  BulkEditMaxItemPreviewDisplayMessage = 'cid$#3811638#',
  BulkEditSkippedItemsPrompt = 'cid$#3811639#',
  BuyFromMarketNTickets = 'cid$#____BuyFromMarketNTickets#',
  ChargeTotalDiscrepancy = 'cid$#3927739#',
  ClassifyAs = 'cid$#3373032#',
  ClearSelections = 'cid$#____ClearSelections#',
  ConfigOption = 'cid$#____ConfigOption#',
  CostPerEventAmount = 'cid$#____CostPerEventAmount#',
  CostPerEventDistributed = 'cid$#____CostPerEventDistributed#',
  CurrencyOriginal = 'cid$#____CurrencyOriginal#',
  CompletedNSecondsAgo = 'cid$#3874913#',
  CompletedNMinutesAgo = 'cid$#3874914#',
  CompletedNHoursAgo = 'cid$#3874915#',
  CopyOf = 'cid$#3512120#',
  CouldNotFindListingId = 'cid$#3037606#',
  CouldNotFindOrderId = 'cid$#3037607#',
  CouldNotFindPaymentId = 'cid$#3927740#',
  CouldNotFindSaleId = 'cid$#2977369#',
  CreatePurchaseOrderProgressTracker = 'cid$#____CreatePurchaseOrderProgressTracker#',
  CreditTotalDiscrepancy = 'cid$#3927741#',
  EditBudgetForActiveFlightOnly = 'cid$#____EditBudgetForActiveFlightOnly#',
  EventNumber = 'cid$#____EventNumber#',
  ExportDateRangeExceedsAvailableData = 'cid$#____ExportDateRangeExceedsAvailableData#',
  FlightNumberX = 'cid$#____FlightNumberX#',
  FloorPriceRollupMetric = 'cid$#____FloorPriceRollupMetric#',
  InheritedFromListing = 'cid$#3927742#',
  InheritedFromPurchase = 'cid$#3927743#',
  MemoryUsageExceeded = 'cid$#____MemoryUsageExceeded#',
  MustShipBySuffix = 'cid$#____MustShipBySuffix#',
  NextNDays = 'cid$#3927745#',
  NextNYear = 'cid$#3927746#',
  NFiltersSelected = 'cid$#____NFiltersSelected#',
  NSucceededMFailed = 'cid$#____NSucceededMFailed#',
  NTickets = 'cid$#____NTickets#',
  NTicketsTimesPrice = 'cid$#____NTicketsTimesPrice#',
  OfValue = 'cid$#4004288#',
  PageOfPages = 'cid$#4004289#',
  PartialPaymentValidationMessage = 'cid$#____PartialPaymentValidationMessage#',
  PaymentTotalDiscrepancy = 'cid$#3927747#',
  PlaceholderEventGroupAllocatedSummary = 'cid$#____PlaceholderEventGroupAllocatedSummary#',
  PlusCountMore = 'cid$#____PlusCountMore#',
  PriceConflictRollupMetric = 'cid$#____PriceConflictRollupMetric#',
  ProceedsTotalDiscrepancy = 'cid$#3927748#',
  PurchaseCompleteSummary = 'cid$#____PurchaseCompleteSummary#',
  RankPremiumRollupMetric = 'cid$#____RankPremiumRollupMetric#',
  RecommendedSections = 'cid$#3927749#',
  RemainingBudget = 'cid$#____RemainingBudget#',
  RemoveSeatingFromCart = 'cid$#____RemoveSeatingFromCart#',
  Reports_LastViewed = 'cid$#____Reports_LastViewed#',
  Reports_NDaysAgo = 'cid$#____Reports_NDaysAgo#',
  Reports_OwnerName = 'cid$#____Reports_OwnerName#',
  Reports_ViewedOnDate = 'cid$#____Reports_ViewedOnDate#',
  RequestNEvents = 'cid$#____RequestNEvents#',
  RequestRetransferInfoMessage = 'cid$#____RequestRetransferInfoMessage#',
  RescheduledFromDate = 'cid$#1800599#',
  SaveAsDefaultConfig = 'cid$#____SaveAsDefaultConfig#',
  SeasonCount = 'cid$#____SeasonCount#',
  SellThroughRateRollupMetric = 'cid$#____SellThroughRateRollupMetric#',
  SoldListingsRollupMetric = 'cid$#____SoldListingsRollupMetric#',
  SoldTicketsMetric = 'cid$#____SoldTicketsMetric#',
  ValueOfValue = 'cid$#4004290#',
  VenueCapacity = 'cid$#____VenueCapacity#',
  ViewAllocReset = 'cid$#3927750#',
  DaysBeforeEvent = 'cid$#3266231#',
  DuplicateListingDetails = 'cid$#3543238#',
  DuplicatingSeats = 'cid$#2975370#',
  EmailAddressFrom = 'cid$#3261278#',
  EmailAddressTo = 'cid$#3261279#',
  EmptyContent = '' /* Used for useContent with an optional content-id */,
  EventDiscoProceedsAdvantageInEffect = 'cid$#3927751#',
  EventsSelected = 'cid$#3361821#',
  EventViews = 'cid$#3927752#',
  EventViewsRemaining = 'cid$#3927753#',
  ExtraBarcodes = 'cid$#2972953#',
  ExtraTicketIds = 'cid$#3389420#',
  ExtraTicketUrls = 'cid$#3389421#',
  Filled = 'cid$#2971998#',
  FirstTimeVenueEventSetup = 'cid$#3811640#',
  FulfilledExternalMarketplace = 'cid$#3070964#',
  GoTo = 'cid$#3172497#',
  HurdleN = 'cid$#3811641#',
  InNDays = 'cid$#2993455#',
  InNHours = 'cid$#3008672#',
  InNMinutes = 'cid$#3008673#',
  InvalidTagCharacter = 'cid$#3373033#',
  ItemsSelected = 'cid$#3195388#',
  LastNDays = 'cid$#2992158#',
  LastNHours = 'cid$#3008674#',
  LastNMinutes = 'cid$#3008675#',
  LastNMonths = 'cid$#3578114#',
  ListingInUKNotification = 'cid$#3172498',
  LoadingListingId = 'cid$#3037602#',
  LoadingOrderId = 'cid$#3037604#',
  LoadingSaleId = 'cid$#2983916#',
  Margin = 'cid$#2971997#',
  MarketOrders_NoListingsMatchFilters = 'cid$#4180418#',
  MarketplaceListings = 'cid$#3874916#',
  MaxAllowedFileSizeMb = 'cid$#3678672#',
  MaxReportSizeWarningMessage = 'cid$#3678673#',
  MedianPriceWarning = 'cid$#3874917#',
  MinDiscountContent = 'cid$#3874918#',
  MissingBarcodes = 'cid$#2972954#',
  MissingTicketIds = 'cid$#3389422#',
  MissingTicketUrls = 'cid$#3389423#',
  NCharactersRemaining = 'cid$#3512121#',
  NCompleted = 'cid$#3373034#',
  NFailed = 'cid$#3373035#',
  NIncreaseBy = 'cid$#3172500#',
  NDays = 'cid$#3008676#',
  NDaysBefore = 'cid$#3008669#',
  NEventsAlreadyActive = 'cid$#____NEventsAlreadyActive#',
  NEventsToBeBoosted = 'cid$#____NEventsToBeBoosted#',
  NEventsNotEligible = 'cid$#____NEventsNotEligible#',
  NHours = 'cid$#3008677#',
  NHoursBefore = 'cid$#3008670#',
  NMinutes = 'cid$#3008678#',
  NMinutesBefore = 'cid$#3008671#',
  NPausedEventsWillBeRestarted = 'cid$#____NPausedEventsWillBeRestarted#',
  NoDataAvailable = 'cid$#3045423#',
  NotificationTypeListingBroadcastFailed = 'cid$#3180468#',
  NotificationTypeListingUnbroadcastFailed = 'cid$#3180475#',
  NotificationTypeListingUpdateAllInPriceFailed = 'cid$#3180469#',
  NotificationTypeListingUpdateInHandDateFailed = 'cid$#3180470#',
  NotificationTypeListingUpdateSplitTypeFailed = 'cid$#3180471#',
  NotificationTypeListingUpdateTicketTypeFailed = 'cid$#3180472#',
  NotificationTypeListingUpdateUnitNetProceedsFailed = 'cid$#3180474#',
  NotificationTypeSellerSupportCaseNewReply = 'cid$#3180476#',
  NotUnique = 'cid$#3110513#',
  NSelected = 'cid$#3874919#',
  NSelectedSections = 'cid$#3389424#',
  NUpdated = 'cid$#3811642#',
  NWarnings = 'cid$#3678674#',
  OnlyForMarketplaces = 'cid$#3811643#',
  OnSaleEventAccessCreditRenewal = 'cid$#3927754#',
  OnSaleEventProceedsMarkup = 'cid$#3927755#',
  OriginalCurrencyPaymentConversionInfo = 'cid$#____OriginalCurrencyPaymentConversionInfo#',
  PacksOf = 'cid$#3543239#',
  PageNum = 'cid$#2975357#',
  PercentageRelativeTo = 'cid$#3432394#',
  ProofOfPurchasedRequiredDetailMessage = 'cid$#3512122#',
  RequestState = 'cid$#3512123#',
  Row = 'cid$#3261280#',
  RowRangeInputError = 'cid$#3811644#',
  SalesForEditTickets = 'cid$#3678675#',
  SalesForRemovedTickets = 'cid$#3678676#',
  SearchingForListingId = 'cid$#3037603#',
  SearchingForOrderId = 'cid$#3037605#',
  SearchingForSaleId = 'cid$#2977368#',
  SearchItem = 'cid$#2973458#',
  SearchResultPick = 'cid$#2983917#',
  SeatAllocationChangeWarning = 'cid$#3089846#',
  SeatNumber = 'cid$#2972034#',
  Section = 'cid$#3261281#',
  ShareQuoted = 'cid$#3432395#',
  ShowingSettingsForOffice = 'cid$#____ShowingSettingsForOffice#',
  SwitchTo = 'cid$#3811645#',
  TakeMeThereInSeconds = 'cid$#3543240#',
  TheseAreThePastSalesOnTheWebsiteAndApp = 'cid$#3432396#',
  TheXthCheapestListing = 'cid$#3988468#',
  TicketCount = 'cid$#3261282#',
  TicketNumber = 'cid$#2975378#',
  TicketPricePercentile = 'cid$#3811646#',
  TicketTypePriority = 'cid$#3243235#',
  TransactionsLastNHour = 'cid$#3874920#',
  TransactionsLastNDay = 'cid$#3874921#',
  UpdatedNMinutesAgo = 'cid$#3927756#',
  Uploading = 'cid$#2975358#',
  UpToXTagsCanBeIncluded = 'cid$#3408222#',
  UrlNumber = 'cid$#2973462#',
  VisitsLastNHour = 'cid$#3874922#',
  VisitsLastNDay = 'cid$#3874923#',
  WebsitePriceRollupMetric = 'cid$#____WebsitePriceRollupMetric#',
  WelcomeUserMessage = 'cid$#2992157#',
  WillDeliverToSecondaryAccount = 'cid$#3261283#',
  YourSaleMetricsPart2 = 'cid$#2992159#',
  YourSaleWithStatus = 'cid$#2992160#',
}
